### FILE: /home/bjorn/src/gdqmarkii/gdq_admin_v3/src/components/GDQAdmin.vue
```
<template>
  <div>
    <Navbar />
    <div class="card col-12">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link active text-center" 
                  id="users-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#users" 
                  type="button" 
                  role="tab"
                  @click="resetstuff"
                >
                  <fa-icon name="user" /><br>Users
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="companies-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#companies" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="users" /><br>Companies
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="partners-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#partners" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="handshake" /><br>Partners
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="gdpr-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#gdpr" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="trash-alt" /><br>GDPR Erase
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="invoicing-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#invoicing" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="file-invoice" /><br>Invoicing
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="coupons-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#coupons" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="tag" /><br>Coupons
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="tutorials-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#tutorials" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="graduation-cap" /><br>Tutorials
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="materials-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#materials" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="file-alt" /><br>Materials
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="settings-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#settings" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="cog" /><br>Settings
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="statistics-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#statistics" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="chart-bar" class="me-2" /><br>Statistics
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link text-center" 
                  id="bulk-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#bulk" 
                  type="button" 
                  role="tab"
                >
                  <fa-icon name="envelope" class="me-2" /><br>Bulk templates
                </button>
              </li>
            </ul>
            
            <div class="tab-content mt-3">
              <div class="tab-pane fade show active" id="users" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Consultants />
                </div>
              </div>
              
              <div class="tab-pane fade" id="companies" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Companies />
                </div>
              </div>
              
              <div class="tab-pane fade" id="partners" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Partners />
                </div>
              </div>
              
              <div class="tab-pane fade" id="gdpr" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <GDPRErase />
                </div>
              </div>
              
              <div class="tab-pane fade" id="invoicing" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <InvoiceReport />
                </div>
              </div>
              
              <div class="tab-pane fade" id="coupons" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Maintenance tablename="g_consultant_coupons" />
                </div>
              </div>
              
              <div class="tab-pane fade" id="tutorials" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Tutorials />
                </div>
              </div>
              
              <div class="tab-pane fade" id="materials" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Materials />
                </div>
              </div>
              
              <div class="tab-pane fade" id="settings" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <SystemSettings />
                </div>
              </div>
              
              <div class="tab-pane fade" id="statistics" role="tabpanel">
                <div class="border-0 mx-auto px-0 col-12">
                  <Statistics />
                </div>
              </div>
              
              <div class="tab-pane fade" id="bulk" role="tabpanel" style="height: 1000px !important">
                <div class="border-0 mx-auto px-0 col-12">
                  <BulkMailDesign />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'GDQAdmin',
  components: {
    Navbar,
    Consultants: defineAsyncComponent(() => import('./Consultants')),
    Companies: defineAsyncComponent(() => import('./Companies')),
    Partners: defineAsyncComponent(() => import('./Partners')),
    GDPRErase: defineAsyncComponent(() => import('./GDPRErase')),
    InvoiceReport: defineAsyncComponent(() => import('./InvoiceReport')),
    Tutorials: defineAsyncComponent(() => import('./Tutorials')),
    Materials: defineAsyncComponent(() => import('./Materials')),
    SystemSettings: defineAsyncComponent(() => import('./SystemSettings')),
    Maintenance: defineAsyncComponent(() => import('./Maintenance')),
    Statistics: defineAsyncComponent(() => import('./Statistics.vue')),
    BulkMailDesign: defineAsyncComponent(() => import('./BulkMailDesign.vue')),
  },
  data() {
    return {
      user_id: this.$store.state.user_id,
      user_name: this.$store.state.user.first_name+' '+this.$store.state.user.family_name,
    }
  },
  mounted() {
    this.resetstuff();
    this.usergroups_get();
  },
  methods: {
    resetstuff() {
      this.$store.dispatch('consultant_setcurrent', { consultant_id: 0});
      this.$store.dispatch('company_setcurrent', { company_id: 0 });
    },
    usergroups_get() {
      this.$store.dispatch('usergroups_fetch');
    }
  }
}
</script>